const FR_ROUTE_MAP = [
  { canonical: '/spare-parts', localized: '/pieces-de-rechange' },
  { canonical: '/about', localized: '/a-propos' },
];

function splitPathQueryHash(input = '') {
  const raw = String(input || '');
  const hashIndex = raw.indexOf('#');
  const queryIndex = raw.indexOf('?');
  const end =
    hashIndex === -1
      ? queryIndex === -1
        ? raw.length
        : queryIndex
      : queryIndex === -1
        ? hashIndex
        : Math.min(hashIndex, queryIndex);
  const pathname = raw.slice(0, end) || '/';
  const suffix = raw.slice(end);
  return { pathname, suffix };
}

function replacePrefix(pathname, from, to) {
  if (pathname === from) return to;
  if (pathname.startsWith(`${from}/`)) {
    return `${to}${pathname.slice(from.length)}`;
  }
  return pathname;
}

function localizePath(path = '/', language = 'en') {
  if (String(language || 'en').toLowerCase() !== 'fr') return String(path || '/');
  const { pathname, suffix } = splitPathQueryHash(path);
  const ordered = [...FR_ROUTE_MAP].sort((a, b) => b.canonical.length - a.canonical.length);
  const localizedPath = ordered.reduce(
    (current, route) => replacePrefix(current, route.canonical, route.localized),
    pathname,
  );
  return `${localizedPath}${suffix}`;
}

function canonicalizePath(path = '/') {
  const { pathname, suffix } = splitPathQueryHash(path);
  const ordered = [...FR_ROUTE_MAP].sort((a, b) => b.localized.length - a.localized.length);
  const canonicalPath = ordered.reduce(
    (current, route) => replacePrefix(current, route.localized, route.canonical),
    pathname,
  );
  return `${canonicalPath}${suffix}`;
}

module.exports = {
  FR_ROUTE_MAP,
  canonicalizePath,
  localizePath,
};
